import React from "react";
const Support = () => {

  return (
    <div className="support-form-container">
      <div>
        <h1>Support</h1>
      </div>
      <div>
        <p className="support-text">For assistance with processes and how-to questions, please contact your designated account manager. </p>
      </div>
      <div>
        <p className="support-text">For all other support needs, email us at dmesupport@wellsky.com</p>
      </div>
    </div>
  );
};


export default Support;